import { CollapseIcon, ExpandIcon } from "@codat/orchard-ui";
import React from "react";

import Button from "components/Button";
import { ButtonProps } from "components/Button/Button";

interface ExpandCollapseButtonProps
  extends Omit<ButtonProps, "onClick" | "children" | "label" | "ref"> {
  isExpanded: boolean;
  onClick: (expand: boolean) => void;
  iconClassName?: string;
}

export const ExpandCollapseButton: React.FC<ExpandCollapseButtonProps> = ({
  eventProperties = {},
  isExpanded,
  onClick,
  iconClassName,
  ...props
}) => {
  return (
    <Button
      eventProperties={{
        value: isExpanded ? "Collapse" : "Expand",
        ...eventProperties,
      }}
      onClick={() => onClick(!isExpanded)}
      {...props}
    >
      {isExpanded ? (
        <CollapseIcon data-testid="collapse-icon" className={iconClassName} />
      ) : (
        <ExpandIcon data-testid="expand-icon" className={iconClassName} />
      )}
    </Button>
  );
};
